module.exports = __webpack_public_path__ + "media/images/emblems/Bellevue-coat_of_arms-232d5eb3989ba8d43b99ae355380a69e.svg";